module.exports = __webpack_public_path__ + "static/media/placeholder13.9e968921.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder13.jpg
// module id = 635
// module chunks = 0